import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './styles/globals.css';
import App from './App';

const rootElement = document.getElementById('root')!;

async function boot(): Promise<void> {
  // Start MSW only when explicitly opted in via VITE_USE_MSW=1.
  // Default is real API via the Vite proxy to the backend.
  if (import.meta.env.VITE_USE_MSW === '1') {
    const { startMockWorker } = await import('./mocks/browser');
    await startMockWorker();
  }

  document.documentElement.classList.add('no-transition');

  createRoot(rootElement).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );

  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      document.documentElement.classList.remove('no-transition');
    });
  });
}

void boot();
